import { BaseComponent } from '../base-component'
import { $el, transitionToPromise } from '../../utils/utils'
import { skipTransition } from '../../utils/dom'

const CONTENT_SELECTOR = `[data-accordeon-content]`

export class AccordeonComponent extends BaseComponent {
  resizeObserver: ResizeObserver
  isExpanded: boolean

  mountComponent(): void {
    this.isExpanded = this.getAttribute('data-aria-expanded') === 'true'
    this.updateHeight()

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)

    if (this.isEditor) {
      this.editor.on('BLOCK_SELECT', this.handleBlockSelect)
      this.editor.on('BLOCK_DESELECT', this.handleBlockDeselect)
    }
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  handleResize = (): void => {
    this.updateHeight()
  }

  handleBlockSelect = ({ detail: { sectionId, blockId, load } }): void => {
    if (
      this.dataset.sectionId === sectionId &&
      this.dataset.blockId === blockId &&
      !this.isExpanded
    ) {
      const content = $el(CONTENT_SELECTOR, this)

      skipTransition(content, load)

      this.show().then(() => {
        skipTransition(content, false)
      })
    }
  }

  handleBlockDeselect = ({ detail: { sectionId, blockId } }): void => {
    if (
      this.dataset.sectionId === sectionId &&
      this.dataset.blockId === blockId &&
      this.isExpanded
    ) {
      this.hide()
    }
  }

  async hide(): Promise<void> {
    await this.setExpand(false)
    this.emit('hide', { blockId: this.dataset.blockId })
  }

  async show(): Promise<void> {
    await this.setExpand(true)
    this.emit('show', { blockId: this.dataset.blockId })
  }

  async toggle(): Promise<void> {
    await this.setExpand(!this.isExpanded)
    this.emit('toggle', { blockId: this.dataset.blockId })
  }

  updateHeight(): void {
    const content = $el(CONTENT_SELECTOR, this)

    if (content) {
      content.style.maxHeight = `${Math.ceil(
        this.isExpanded ? content.scrollHeight : 0,
      )}px`
    }
  }

  async setExpand(isExpanded: boolean): Promise<void> {
    this.isExpanded = isExpanded
    this.setAttribute('data-aria-expanded', isExpanded ? 'true' : 'false')
    this.updateHeight()
    await transitionToPromise(this)
  }
}
